import request from "@/utils/request";  //导入封装请求的js文件
 
export function list(params) {
  return request({
    url: "/memberApi/product/list",  //接口路径
    method: "get",  //接口方法
    params  //接口参数
  });
}

export function info(id) {
  return request({
    url: "/memberApi/product/" + id,  //接口路径
    method: "get",  //接口方法
  });
}

export function addBrowse(params) {
  return request({
    url: "/memberApi/product/addBrowse/"+params,  //接口路径
    method: "put",  //接口方法
  });
}
